import { styled } from '@innowise-group/mui-kit';

export const AuthContainer = styled.section`
  display: flex;
  height: 100vh;
  width: 100%;
  flex-wrap: wrap;
`;
